module.exports = __webpack_public_path__ + "public/Icons/bookingIcon.svg?54f8bf63";